<template>
  <v-flex v-bind:class="postType">
    <v-data-table flat class="mt-4 vt-data-table" :headers="headers" :items="items2" v-model="items2" hide-actions
      @load="onUpdate(items2, function(data){ items2=data;});">
      <template slot="headerCell" slot-scope="props">
        <v-tooltip bottom>
          <span slot="activator">
            {{ props.header.text }}
          </span>
          <span>
            {{ props.header.text }}
          </span>
        </v-tooltip>
      </template>
      <template slot="items" slot-scope="props">
        <td>
          <v-btn icon class="mx-0" @click.stop="confirmDeleteItem(props.item)">
            <v-icon color="grey">delete</v-icon>
          </v-btn>
          <div class="activity">
            {{ props.item.activityType }}</div>
          <div class="caption mt-1">{{ props.item.notes}}</div>
        </td>
        <td v-if="props.item.intensity">{{ props.item.intensity}}</td>
        <td v-if="props.item.activityType !== 'VoiceCeilingPitch'" class="">{{ props.item.value }}</td>
        <td v-if="false" class="justify-center layout px-0">
          <v-btn icon class="mx-0" @click="deleteItem(props.item)">
            <v-icon color="grey">delete</v-icon>
          </v-btn>
        </td>
      </template>
    </v-data-table>
    <v-btn v-if="false" class="mx-0" @click="onUpdate(items2, function(data){ items2=data;});">Update</v-btn>
    <v-dialog v-model='deleteDialog'>
      <v-card>
        <v-card-title class="headline">Are you sure you want to delete this item?</v-card-title>
        <v-card-text>
          <div>Activity: {{itemBeingDeleted.activityType}}</div>
          <div v-if='itemBeingDeleted.intensity !=null'>Intensity: {{itemBeingDeleted.intensity}}</div>
          <div v-if='itemBeingDeleted.value !=null'>Value: {{itemBeingDeleted.value}}</div>
        </v-card-text>
        <v-card-actions>
          <v-btn flat="flat" @click="deleteDialog=false">
            Cancel
          </v-btn>
          <v-btn flat="flat" @click="deleteItem">
            Delete
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </v-flex>
</template>

<script>
  import { ListActivitiesForCurrentUser, GetActivityByUserQuery } from '@/components/queries'
  import DeleteActivityMutation from '../mutations/DeleteActivityMutation'

  function filterForActivities (items) {
    var temp = items.filter(item => item.activityType !== 'NapTaken')
      .filter(item => item.activityType !== 'WaterConsumption')
      .filter(item => item.activityType !== 'VoiceCeilingPitch')
      .filter(item => item.activityType !== 'VoiceFeeling')
      .filter(item => item.activityType !== 'Sick')
    return temp
  }
  function filterForNaps (items) {
    var temp = items.filter(item => item.activityType === 'NapTaken')
    return temp
  }
  function filterForWater (items) {
    var temp = items.filter(item => item.activityType === 'WaterConsumption')
    return temp
  }
  function filterForPitch (items) {
    return items.filter(item => item.activityType === 'VoiceCeilingPitch')
  }

  export default {
    data () {
      console.log(localStorage)
      return {
        title: '',
        date: localStorage.currentDate,
        headers: [
          { text: 'Activity', align: 'left', value: 'activityType' },
          { text: 'Intensity', align: '', value: 'intensity' },
          { text: 'Value', align: '', value: 'value' }
        ],
        items2: [],
        deleteDialog: false,
        itemBeingDeleted: {
          activityType: null,
          intensity: null,
          value: null,
          id: null
        }
      }
    },

    methods: {
      async getActivities () {
        console.log('get activities')
        const { data } = await this.$apollo.query({
          variables: {
            actDate: localStorage.currentDate
          },
          query: ListActivitiesForCurrentUser
        })

        const items = data.listActivitiesForCurrentUser.items || []

        if (this.postType === 'NapTaken') {
          return filterForNaps(items)
        } else if (this.postType === 'WaterConsumption') {
          return filterForWater(items)
        } else if (this.postType === 'Pitch') {
          return filterForPitch(items)
        } else {
          return filterForActivities(items)
        }
      },

      confirmDeleteItem (item) {
        const index = this.items2.indexOf(item)
        this.itemBeingDeleted.activityType = this.items2[index].activityType
        this.itemBeingDeleted.intensity = this.items2[index].intensity
        this.itemBeingDeleted.value = this.items2[index].value
        this.itemBeingDeleted.id = this.items2[index].id
        this.deleteDialog = true
      },
      async deleteItem () {
        this.deleteDialog = false
        const data = await this.$apollo.mutate({
          variables: {
            input: {
              id: this.itemBeingDeleted.id
            }
          },
          mutation: DeleteActivityMutation
        })

        this.$root.$emit('DateChange', data)
        this.items2 = await this.getActivities()
      },

      async onUpdate () {
        console.log('on update')
        const data = await this.getActivities()
        this.items2 = data
        return data
      }

    },
    async created () {
      this.items2 = await this.getActivities()
    },
    mounted () {
      if (this.postType === 'Water' || this.postType === 'Naps') {
        this.headers = [
          { text: 'Activity', align: 'left', value: 'activityType' },
          { text: 'Value', align: '', value: 'value' }
        ]
      }
      if (this.postType === 'Pitch') {
        this.headers = [
          { text: 'Activity', align: 'left', value: 'activityType' },
          { text: 'Ceiling Pitch', align: '', value: 'intensity' }
        ]
      }
    },
    async updated () {
    },
    props: [
      'postTitle',
      'postFeelings',
      'postType'
    ]
  }
</script>


<style>
  .vt-data-table table.table tbody td:first-child div.activity {
    display: inline-flex;
  }

  @media (max-width: 500px) {

    .vt-data-table td:nth-child(2),
    .vt-data-table th:nth-child(2) {
      display: none;
    }

    .Pitch .vt-data-table td:nth-child(2),
    .Pitch .vt-data-table th:nth-child(2) {
      display: table-cell;
    }

    .Water .vt-data-table td:nth-child(2),
    .Water .vt-data-table th:nth-child(2),
    .Naps .vt-data-table td:nth-child(2),
    .Naps .vt-data-table th:nth-child(2) {
      display: table-cell;
    }

    .vt-data-table table.table tbody td:first-child {
      min-width: 80px;
      line-height: 1rem;
    }

    .vt-data-table table.table tbody td:first-child,
    .vt-data-table table.table tbody td:not(:first-child),
    .vt-data-table table.table thead td:first-child,
    .vt-data-table table.table thead td:not(:first-child),
    .vt-data-table table.table tbody th:not(:first-child),
    .vt-data-table table.table thead th:not(:first-child) {
      padding: 0 0px;

    }

    .vt-data-table table.table tbody th:first-child,
    .vt-data-table table.table thead th:first-child {
      padding: 0 8px;
    }
  }
</style>


// WEBPACK FOOTER //
// src/components/val/ValDataTable.vue